// extracted by mini-css-extract-plugin
module.exports = {"container":"orderInfoData_container__3APSD","icon":"orderInfoData_icon__ktNsp","content":"orderInfoData_content__3OO9W"};